/*
 * @Description  :
 * @Version      : 1.0.0
 * @Author       : Luoye
 * @Date         : 2022-05-11 14:52:15
 * @LastEditors  : Luoye
 * @FilePath     : /namibox_client_web/src/views/app-guide.ReactPage/App.tsx
 * Copyright (C) 2022 rose. All rights reserved.
 */
import React, { Suspense, lazy } from 'react';
import {
  Redirect,
  Route,
  HashRouter as Router,
  Switch,
} from 'react-router-dom';

const InstallPage = lazy(
  () => import(/* webpackChunkName: "InstallPage" */ './pages/Install/index')
);

const InstallPage_latestApp = lazy(
  () =>
    import(
      /* webpackChunkName: "InstallPage_latestApp" */ './pages/Install/latestApp'
    )
);

const InstallPage_AppStore = lazy(
  () =>
    import(
      /* webpackChunkName: "InstallPage_AppStore" */ './pages/Install/appStore'
    )
);

const InstallPage_AppMarket = lazy(
  () =>
    import(
      /* webpackChunkName: "InstallPage_AppMarket" */ './pages/Install/appMarket'
    )
);

const CommentPage_ToAppStore = lazy(
  () =>
    import(
      /* webpackChunkName: "CommentPage_ToAppStore" */ './pages/Comment/index'
    )
);

const NewDownloadPage = lazy(
  () =>
    import(/* webpackChunkName: "NewDownloadPage" */ './pages/NewDownloadPage')
);
const DDLoad = lazy(
  () => import(/* webpackChunkName: "DDLoad" */ './pages/DDLoad')
);

const SmsLoad = lazy(
  () => import(/* webpackChunkName: "SmsLoad" */ './pages/SmsLoad')
);
const WxminiProgramLoad = lazy(
  () =>
    import(
      /* webpackChunkName: "WxminiProgramLoad" */ './pages/WxminiProgramLoad'
    )
);

const OpenBookPage = lazy(
  () => import(/* webpackChunkName: "OpenBookPage" */ './pages/OpenBookPage')
);
const Zhixuetong = lazy(
  () => import(/* webpackChunkName: "Zhixuetong" */ './pages/Zhixuetong')
);

const Wangzhaoxia = lazy(
  () => import(/* webpackChunkName: "Wangzhaoxia" */ './pages/Wangzhaoxia')
);

const QrCode = lazy(
  () => import(/* webpackChunkName: "QrCode" */ './pages/QrCode')
);

const OnlyNamibox = lazy(
  () => import(/* webpackChunkName: "OnlyNamibox" */ './pages/OnlyNamibox')
);

const App: React.FC = () => {
  return (
    <>
      <Router>
        <Suspense fallback={<div />}>
          <Switch>
            <Redirect exact path="/" to={{ pathname: '/install' }} />
            {/* 跳转到 appstore 下载 */}
            <Route
              exact
              path="/install"
              component={() => <InstallPage_AppStore />}
            />
            <Route
              exact
              path="/appmarket"
              component={() => <InstallPage_AppMarket />}
            />
            {/* 原始下载方式 */}
            <Route
              exact
              path="/origin-install"
              component={() => <InstallPage />}
            />
            {/* 下载app最新版本apk */}
            <Route
              exact
              path="/origin-install-apk"
              component={() => <InstallPage_latestApp />}
            />

            {/* 去应用市场评论 */}
            <Route
              exact
              path="/comment-to-appstore"
              component={() => <CommentPage_ToAppStore />}
            />
            <Route
              exact
              path="/appstore"
              component={() => <NewDownloadPage />}
            />
            <Route exact path="/dd-load" component={() => <DDLoad />} />
            <Route exact path="/sms-load" component={() => <SmsLoad />} />
            <Route
              exact
              path="/wx-miniprogram-load"
              component={() => <WxminiProgramLoad />}
            />
            <Route exact path="/open-book" component={() => <OpenBookPage />} />
            <Route exact path="/zhixuetong" component={() => <Zhixuetong />} />
            <Route
              exact
              path="/wangzhaoxia"
              component={() => <Wangzhaoxia />}
            />
            <Route exact path="/qrcode" component={() => <QrCode />} />
            <Route
              exact
              path="/only-namibox"
              component={() => <OnlyNamibox />}
            />
          </Switch>
        </Suspense>
      </Router>
    </>
  );
};
export default App;
